module.exports = __webpack_public_path__ + "img/myposition_dm_로드리.807b4622.png";